module.exports = {"id":"150516","name":"Lukas Podolski","rating":"78","photo":"./data/images/photos/0/150516.png","club":{"name":"Vissel Kobe","logo":"./data/images/clubs/VisselKobe.png"},"positions":["BU","MD","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LukasPodolski0.json
// module id = 2639
// module chunks = 0